export enum EnumMasterInsuranceSubState {
  "insurance_creating" = "insurance_creating",
  "insurance_package_creating" = "insurance_package_creating",
  "validating" = "validating",
  "completed" = "completed",
  "weight_creating" = "weight_creating",
  // "freelance_insurance_creating" = "freelance_insurance_creating",
}

export const MasterInsuranceSubStateKey = "INSURANCE_SUB_STATE_KEY";
